export const MODAL_EVENTS = {
  open: 'modal:open',
  close: 'modal:close',
  toggle: 'modal:toggle',
  opened: 'modal:opened',
  closed: 'modal:closed',
};

export default class Modal extends HTMLElement {
  POSSIBLE_DIRECTIONS = ['left-to-right', 'right-to-left', 'top-to-bottom', 'bottom-to-top'];

  MODAL_EVENTS = MODAL_EVENTS;

  DESKTOP_BREAKPOINT = 1024;

  groupId = this.getAttribute('data-group-id') || null;

  #handleOpen;
  #handleClose;
  #handleToggle;

  constructor() {
    super();
  }

  connectedCallback() {
    this.style.display = '';

    this.checkValidDirection();
    this.checkIdExistence();

    this.loadInitialState();

    this.#handleOpen = this.#checkEvent(this.open.bind(this));
    this.#handleClose = this.#checkEvent(this.close.bind(this));
    this.#handleToggle = this.#checkEvent(this.toggle.bind(this));

    document.addEventListener(MODAL_EVENTS.open, this.#handleOpen);
    document.addEventListener(MODAL_EVENTS.close, this.#handleClose);
    document.addEventListener(MODAL_EVENTS.toggle, this.#handleToggle);
  }

  disconnectedCallback() {
    document.removeEventListener(MODAL_EVENTS.open, this.#handleOpen);
    document.removeEventListener(MODAL_EVENTS.close, this.#handleClose);
    document.removeEventListener(MODAL_EVENTS.toggle, this.#handleToggle);
  }

  checkValidDirection() {
    const direction = this.getAttribute('data-direction') || 'left-to-right';

    if (!this.POSSIBLE_DIRECTIONS.includes(direction)) {
      this.setAttribute('data-direction', 'left-to-right');
      console.error(`Invalid direction: ${direction}. Setting direction to left-to-right`);
    }
  }

  checkIdExistence() {
    if (!this.id) {
      throw new Error('Modal must have an id');
    }
  }

  open() {
    this.setAttribute('data-open', '');
    this.dispatchEvent(
      new CustomEvent(MODAL_EVENTS.opened, {
        bubbles: true,
        detail: { id: this.id, groupId: this.groupId },
      }),
    );
  }

  close() {
    this.removeAttribute('data-open');
    this.dispatchEvent(
      new CustomEvent(MODAL_EVENTS.closed, {
        bubbles: true,
        detail: { id: this.id, groupId: this.groupId },
      }),
    );
  }

  toggle() {
    this.toggleAttribute('data-open');

    const eventName = this.hasAttribute('data-open') ? MODAL_EVENTS.opened : MODAL_EVENTS.closed;
    this.dispatchEvent(
      new CustomEvent(eventName, {
        bubbles: true,
        detail: { id: this.id, groupId: this.groupId },
      }),
    );
  }

  #checkEvent(callback) {
    return event => {
      if (event.detail?.id === this.id) {
        callback();
      }
    };
  }

  loadInitialState() {
    const windowBreakpoint = window.innerWidth;

    if (windowBreakpoint >= this.DESKTOP_BREAKPOINT && this.hasAttribute('data-starts-opened-desktop')) {
      this.open();
      this.removeAttribute('data-starts-opened-desktop');
    } else if (windowBreakpoint < this.DESKTOP_BREAKPOINT && this.hasAttribute('data-starts-opened-mobile')) {
      this.open();
      this.removeAttribute('data-starts-opened-mobile');
    }
  }
}
